import styled from "@emotion/styled";

export const OptionsList = styled.ul`
    padding: 5px 10px;
`;

export const Item = styled.li`
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  margin-bottom: 5px;
  padding: 5px;
  font-size: 18px;
`;

export const Grade = styled.p`
 color: rgb(55, 90, 99);
`;

export const ItemValue = styled.span`
 color: rgb(55, 90, 99);
`;